import { apiGet, apiPatch } from '@/lib/api';

/**
 * User settings interface
 */
export interface UserSettings {
  defaultModel?: string; // 只读，从后端获取
  llmModel?: string; // 用户选择的模型
  language: string;
  llmLanguage: string;
  defaultClientId?: string; // 默认客户端ID
  instructions?: string; // 用户指令
}

/**
 * User profile response
 */
export interface UserProfileResponse {
  id: number;
  name: string;
  email: string;
  isAdmin: boolean;
  isDeveloper: boolean;
  settings: UserSettings;
  code: number;
  message: string;
}

/**
 * 获取用户配置信息
 */
export async function fetchUserProfile(): Promise<UserProfileResponse | null> {
  try {
    const response = await apiGet<UserProfileResponse>('/api/user/profile');
    // API response could be wrapped in data property or be the direct response
    const data = (response as any)?.data || response;

    if (data && data.code === 200 && data.settings) {
      return data as UserProfileResponse;
    }

    console.error(
      'Failed to fetch user profile:',
      data?.message || 'Unknown error'
    );
    return null;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }
}

/**
 * 更新用户设置（使用 PATCH 请求，只发送变更的字段）
 */
export async function updateUserSettings(
  settings: Partial<UserSettings>
): Promise<boolean> {
  try {
    const response = await apiPatch('/api/user/settings', settings);
    const data = response?.data || response || {};

    if (data.code === 200) {
      return true;
    }

    console.error('Failed to update user settings:', data.message);
    return false;
  } catch (error) {
    console.error('Error updating user settings:', error);
    return false;
  }
}
